import * as Braze from "@braze/web-sdk";
import * as Sentry from "@sentry/react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Navigate, Route, Routes } from "react-router-dom";

import { AuthProvider } from "./auth";
import { Layout } from "./components/layout";
import { BRAZE_API_KEY, BRAZE_SDK_ENDPOINT } from "./constants";
import { FeatureFlagsProvider } from "./feature-flag";
import "./i18n";
import { Logger } from "./logger";
import { Metrics, MetricsContext } from "./metrics";
import { AddAddress } from "./pages/add-address";
import { Birthdate } from "./pages/add-birthdate";
import { AddEmail } from "./pages/add-email";
import { AddPhone } from "./pages/add-phone";
import { Agreements } from "./pages/agreements";
import { AppDownload } from "./pages/app-download";
import ApplePayFaq from "./pages/apple-pay-faq";
import { Chat } from "./pages/chat";
import { Home } from "./pages/home";
import { PageFailed } from "./pages/page-failed";
import { Profile } from "./pages/profile";
import { RegisterCompleted } from "./pages/register-completed";
import { RequestCard } from "./pages/request-card";
import { SignIn } from "./pages/sign-in";
import { Transactions } from "./pages/transactions";
import { UnsignedAgreement } from "./pages/unsigned-agreement";
// import { VirtualCardDetails } from "./pages/virtual-card-details";
import { RequestCardProvider } from "./requestCardProvider";
import { ROUTES } from "./routes";
import { PrivateRoute } from "./services/private-route";

Metrics.init();
Logger.init();
const STALE_TIME = 120000;

const App = () => {
  Braze.initialize(BRAZE_API_KEY, {
    baseUrl: BRAZE_SDK_ENDPOINT,
    doNotLoadFontAwesome: true,
  });
  const SentryRoutes = Sentry.withSentryReactRouterV6Routing(Routes);
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        retry: false,
        staleTime: STALE_TIME,
      },
    },
  });

  return (
    <AuthProvider>
      <QueryClientProvider client={queryClient}>
        <MetricsContext.Provider value={Metrics}>
          <FeatureFlagsProvider>
            <RequestCardProvider>
              <SentryRoutes>
                <Route
                  path={ROUTES.ALL}
                  element={<Navigate to="/" replace />}
                />
                <Route path={ROUTES.APP_DOWNLOAD} element={<AppDownload />} />
                <Route path={ROUTES.ADD_EMAIL} element={<AddEmail />} />
                <Route
                  path={ROUTES.REGISTER_COMPLETED}
                  element={<RegisterCompleted />}
                />
                <Route path={ROUTES.CHAT} element={<Chat />} />
                <Route path={ROUTES.PAGE_FAILED} element={<PageFailed />} />
                <Route path={ROUTES.SIGN_IN} element={<SignIn />} />
                <Route path={ROUTES.APPLE_PAY_FAQ} element={<ApplePayFaq />} />
                <Route element={<PrivateRoute />}>
                  <Route path={ROUTES.REQUEST_CARD} element={<RequestCard />} />
                  <Route path={ROUTES.ADD_ADDRESS} element={<AddAddress />} />
                  <Route path={ROUTES.ADD_PHONE} element={<AddPhone />} />
                  <Route path={ROUTES.BIRTHDATE} element={<Birthdate />} />
                  <Route element={<Layout />}>
                    <Route path={ROUTES.PROFILE} element={<Profile />} />
                    <Route
                      path={ROUTES.TRANSACTIONS}
                      element={<Transactions />}
                    />
                    {/* <Route
                      path={ROUTES.VIRTUAL_CARD_DETAILS_ID}
                      element={<VirtualCardDetails />}
                    /> */}
                  </Route>
                  <Route path={ROUTES.HOME} element={<Home />} />
                  <Route
                    path={ROUTES.NOVATION_CONTRACT}
                    element={<Agreements />}
                  />
                  <Route
                    path={ROUTES.UNSIGNED_NOVATION_CONTRACT}
                    element={<UnsignedAgreement />}
                  />
                </Route>
              </SentryRoutes>
            </RequestCardProvider>
          </FeatureFlagsProvider>
        </MetricsContext.Provider>
      </QueryClientProvider>
    </AuthProvider>
  );
};
export default App;
